import { render } from "./WorkAreaDetails.vue?vue&type=template&id=3d1e4868"
import script from "./WorkAreaDetails.vue?vue&type=script&lang=ts"
export * from "./WorkAreaDetails.vue?vue&type=script&lang=ts"
script.render = render

export default script